export enum FavoriteType {
  URL = 'URL', EXDASHBOARD = 'EXDASHBOARD', OBJECT = 'OBJECT', MENU = 'MENU', MENU_ADMIN = 'MENU_ADMIN', MENU_APP = 'MENU_APP'
}

export interface FavoriteModel {
  'id': number;
  'url': string;
  'description': string;
  'linktype': FavoriteType;
  'linkobjid': number;
}
